import React from 'react';
import { Icon } from 'antd';
import { Link } from 'react-router-dom';

export default ({ collapsed }) => {
  return (
    <div className="isoLogoWrapper">
      {collapsed ? (
        <div>
          <h3>
            <Link to="/admin">
              <Icon component={() => <img src="/digi-logo.png" alt="" />} />
            </Link>
          </h3>
        </div>
      ) : (
        <h3>
          <Link to="/admin">
            <Icon component={() => <img src="/digi_logo.svg" alt="" />} />
          </Link>
        </h3>
      )}
    </div>
  );
};
